import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../Support/with_presenter';
import {CrewsWorkoutIndexPresenter} from './CrewsWorkoutIndexPresenter';
import {Loader} from '../Components/Utils/Loader';
import {CrewsWorkoutsTable} from './Components/CrewsWorkoutsTable';
import {NetworkRequestStatusView} from '../Components/Utils/NetworkRequestStatusView';
import {ErrorPlaceholder} from '../Components/Utils/ErrorPlaceholder';
import {FullCrew} from '../../Models/Crew';
import {WorkoutDateRangePicker} from '../Components/Form/WorkoutDateRangePicker';
import {FeatureFlags} from '../../FeatureFlags';

interface OwnProps {
    crews: FullCrew[];
}

const CrewsWorkoutIndexComponent: FunctionComponent<OwnProps & PresenterProps<CrewsWorkoutIndexPresenter>> = observer(
    ({presenter}) => {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="row mb-2">
                            <div className="col-sm-5 d-flex flex-row gap-3 mb-2">
                                <WorkoutDateRangePicker
                                    className="flex-grow-1"
                                    range={presenter.filter?.dateRange}
                                    onChange={(range) => presenter.updateDateRange(range)}
                                />
                            </div>
                            <div className="col-sm-7 d-flex flex-row gap-3 mb-2">
                                <button className="btn btn-primary" onClick={() => presenter.resetFilter()}>
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <NetworkRequestStatusView
                    result={presenter.result}
                    loader={() => (
                        <div className="row">
                            <div className="col-12">
                                <Loader className="mt-5" />
                            </div>
                        </div>
                    )}
                    error={() => (
                        <div className="row">
                            <div className="col-12">
                                <ErrorPlaceholder large className="mt-5" />
                            </div>
                        </div>
                    )}
                    component={(data) => (
                        <CrewsWorkoutsTable
                            partialWorkouts={data}
                            page={presenter.filter.page}
                            previousPage={() => presenter.previousPage()}
                            nextPage={() => presenter.nextPage()}
                            onPageChange={(page) => presenter.onPageChange(page)}
                            userList={presenter.userList}
                        />
                    )}
                />
            </div>
        );
    },
);

export const CrewsWorkoutIndex = withPresenter<CrewsWorkoutIndexPresenter, OwnProps>((props, component) => {
    const crewIds = props.crews
        .filter((crew) => !FeatureFlags.isAdvancedSubscriptionsEnabled || crew.isAdvanced)
        .map((crew) => crew.id);
    return new CrewsWorkoutIndexPresenter(component.network.workouts, crewIds, props.crews);
}, CrewsWorkoutIndexComponent);
